"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clientShape = exports.listShape = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("./constants");

var JWT = _constants.accessTokenTypes.JWT,
    REFERENCE = _constants.accessTokenTypes.REFERENCE;

var listShape = _propTypes.default.oneOfType([_propTypes.default.shape({
  value: _propTypes.default.string
}), _propTypes.default.string]);

exports.listShape = listShape;

var clientShape = _propTypes.default.shape({
  id: _propTypes.default.string,
  tempId: _propTypes.default.string,
  name: _propTypes.default.string,
  enabled: _propTypes.default.bool,
  secret: _propTypes.default.string,
  allowedGrantTypes: _propTypes.default.arrayOf(_propTypes.default.string),
  redirectUris: _propTypes.default.arrayOf(listShape),
  postLogoutRedirectUris: _propTypes.default.arrayOf(listShape),
  allowedCorsOrigins: _propTypes.default.arrayOf(listShape),
  requireConsent: _propTypes.default.bool,
  scopes: _propTypes.default.arrayOf(_propTypes.default.string),
  allowOfflineAccess: _propTypes.default.bool,
  accessTokenLifetimeSeconds: _propTypes.default.number,
  tenantAccessPolicy: _propTypes.default.string,
  roles: _propTypes.default.arrayOf(_propTypes.default.string),
  accessTokenType: _propTypes.default.oneOf([JWT, REFERENCE])
});

exports.clientShape = clientShape;
//# sourceMappingURL=shapes.js.map